import Vue from "vue";
import Vuex from "vuex";
import _ from "lodash";
import { getDevice, isWeixin, isLogin, isSafari } from "@/config/utils";
Vue.use(Vuex);

const state = {
  isWx: isWeixin(),
  isPc: false, //是否pc访问
  app_token: "", //token
  refreshToken: "", //更新令牌
  wechatToken: "", //jssdk token
  isLoading: false,
  device: getDevice(),
  maskView: "none",
  direction: 'forward',
  wxSignUrl: null,
  agentId: "",
  cacheArr: [],
  custId: "",
  loginStatus: isLogin(), //登陆状态 T/F
  isSafari: isSafari(),
  isAppClientType: false
};

const mutations = {
  setToken(state, data) {
    state.app_token = data.accessToken;
    if (data.refreshToken) {
      state.refreshToken = data.refreshToken;
    }
  },
  //点击清除之前所有缓存的页面
  clearCacheArr(state) {
    state.cacheArr = []
  },
  //清空缓存后再将待缓存的页面添加
  setCacheArr(state) {
    state.cacheArr = []
  },
  setUrl(state, data) {
    state.wxSignUrl = data
  },
  clearCacheByName(state, pageName) {
    let cacheList = state.cacheArr
    for (let i = 0; i < cacheList.length; i++) {
      if (cacheList[i] == pageName) {
        cacheList.splice(i, 1)
      }
    }
  },
  setCacheByName(state, pageName) {
    state.cacheArr.push(pageName)
  },
  //按钮遮罩显示
  showMaskView(state) {
    state.maskView = 'block'
  },
  //按钮遮罩隐藏
  hideMaskView(state) {
    state.maskView = 'none'
  },
  //路由跳转加载
  updateLoadingStatus(state, payload) {
    state.isLoading = payload.isLoading
  },
  // 改变进出栈方向
  updateDirection(state, payload) {
    state.direction = payload.direction
  },
  // 存储客户列表客户信息
  saveCustomerData(state, payload) {
    state.customerData = payload
  },
  //保存登陆状态
  saveLoginStatus(state, status) {
    state.loginStatus = status
  },
  //设置clientType
  setclientType(state, value) {
    state.isWx = value
  },
  //设置app clientType
  setAppClientType(state, value) {
    state.isAppClientType = value
  }
};

const actions = {};

export default new Vuex.Store({
  state,
  actions,
  mutations
});



// WEBPACK FOOTER //
// ./src/store/index.js